import React from "react";
import style from "css/modal.module.css";
import { Modal } from "antd";
import { useTranslation } from "react-i18next";

function OpenModal(props) {
  const info = () => {
    Modal.info({
      //   className: style.logout_container,
      centered: true,
      title: <p className={style.modal_title}>{props.title}</p>,
      icon:
        props.img !== undefined ? (
          <img
            src={props.img}
            alt=""
            className={`${style.modal_icon} anticon`}
          />
        ) : null,
      content: <p className={style.modal_content}>{props.content}</p>,
      // okText: t("common.button.ok"),
      okText: props.okText,
      okType: "dashed",
      okButtonProps: {
        className: style.green_btn,
      },
      onOk() {
        props.btnEvent();
      },
    });
  };

  const confirm = () => {
    Modal.confirm({
      centered: true,
      title: <p className={style.modal_title}>{props.title}</p>,
      icon:
        props.img !== undefined ? (
          <img
            src={props.img}
            alt=""
            className={`${style.modal_icon} anticon`}
          />
        ) : null,
      content: <p className={style.modal_content}>{props.content}</p>,
      okText: "확인",
      okType: "dashed",
      okButtonProps: {
        className: style.white_btn,
      },
      cancelText: "취소",
      cancelButtonProps: {
        className: style.green_btn,
        type: "dashed",
      },
      onOk() {
        props.btnEvent();
      },
    });
  };

  const popup = () => {
    Modal.success({
      icon: null,
      centered: true,
      title: <p className={style.modal_title}>{props.title}</p>,
      content: <p className={style.modal_content}>{props.content}</p>,
      //   okText: "확인",
      //   okType: "dashed",
      //   okButtonProps: {
      //     className: style.green_full_btn,
      //   },
      //   onOk() {
      //     props.btnEvent();
      //     popup.destroy();
      //   },
    });
  };

  const setModal = () => {
    switch (props.type) {
      case "info":
        info();
        break;
      case "confirm":
        confirm();
        break;
      case "popup":
        popup();
        break;
      default:
        break;
    }
  };

  return setModal();
}

export default OpenModal;
